import { render, staticRenderFns } from "./PublicLargeCode.vue?vue&type=template&id=37145d3f&scoped=true"
import script from "./PublicLargeCode.vue?vue&type=script&lang=js"
export * from "./PublicLargeCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37145d3f",
  null
  
)

export default component.exports